

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getCookie } from "@szgc/plt-core-v2";
// import SzgcFormGetor from "../../../gt/package/SzgcFormGetor/index.vue";
import request from "../../api/request";
import Api from "../../api";

// Vue.component("SzgcFormGetor", SzgcFormGetor);

@Component({
  name: "ModelViewForm",
  components: {
    SzgcFormGetor: () => import("../../../gt/package/SzgcFormGetor/index.vue")
  }
})
export default class ModelViewForm extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  private prefix: any = "";
  private pageData: any = null;
  private status: string = "";
  private formConfig: any = {
    auths: "",
    formRenderData: "",
    results: "",
    businessId: "",
    businessName: "",
    pacId: "",
    reqToken: ""
  };
  private ifProcess: boolean = false;

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    this.prefix = getCookie("plt-api-route") || "";
    if (newVal) {
      this.pageData = JSON.parse(JSON.stringify(newVal));
      this.ifProcess = this.pageData.ifProcess;
      if (this.pageData.type === "add") {
        this.status = "mine";
      } else if (this.pageData.type === "update") {
        this.status = "todo";
      } else if (this.pageData.type === "detail") {
        this.status = "fine";
      }
      if (this.pageData.type === "add") {
        this.getInitData();
      } else {
        this.getDetail();
      }
    }
  }

  /*获取新增初始数据*/
  async getInitData() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.flowInitRead(),
        method: "post",
        data: {
          clientType: "web",
          flowCfgId: this.pageData.flowConfigId
        }
      });
      if (!success) {
        this.$message.error("获取表单初始配置失败:" + message);
      }
      try {
        this.formConfig = {
          packageType: data.packageType,
          auths: data.auths,
          formRenderData: data.formRender,
          results: data.fields,
          businessId: data.businessId,
          businessName: data.businessName,
          pacId: data.pacId,
          reqToken: data.reqToken
        };
        // 如果是无流程，则需要根据表单配置生成权限，而不是流程配置的权限
        if (!this.pageData.ifProcess) {
          const formRender = JSON.parse(data.formRender);
          if (Array.isArray(formRender.widgets)) {
            // 主表单权限
            const auths = formRender.widgets.reduce((pre: any, item: any) => {
              pre[item.path] = {
                children: null,
                read: true,
                required: item.required,
                write: !item.readonly
              };
              // TODO 子表单权限，子表单暂时不能在表单配置中配置权限，所以暂时不处理
              // if (item.children && Array.isArray(item.children)) {
              //   pre[item.path].children = item.children.reduce((pre: any, item: any) => {
              //     pre[item.path] = {
              //       children: null,
              //       read: true,
              //       required: item.required,
              //       write: !item.readonly
              //     };
              //     return pre;
              //   }, {});
              // }
              return pre;
            }, {});

            this.formConfig.auths = { ...this.formConfig.auths, ...auths };
          }
        }
      } catch (error) {
        this.formConfig = {
          packageType: data.packageType,
          auths: data.auths,
          formRenderData: data.formRender,
          results: data.fields,
          businessId: data.businessId,
          businessName: data.businessName,
          pacId: data.pacId,
          reqToken: data.reqToken
        };
      }
    } catch (error: any) {
      this.$message.error("获取表单初始配置失败:" + error);
    }
  }

  /*查询详情数据*/
  async getDetail() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getDyForm(),
        method: "post",
        data: {
          app: false,
          businessId: this.pageData.data.businessId,
          dataViewCfgId: this.pageData.dataViewCfgId
        }
      });
      if (!success) {
        this.$message.error("查询详情数据失败:" + message);
      }
      this.formConfig = {
        packageType: this.pageData.packageType,
        auths: data.auths,
        formRenderData: data.formRender,
        results: data.fields,
        businessId: this.pageData.data.businessId,
        pacId: this.pageData.pacId,
        reqToken: this.pageData.reqToken
      };
    } catch (error: any) {
      this.$message.error("查询详情数据失败:" + error);
    }
  }

  /*新增*/
  async add() {
    let formData: any = null;
    const allData = await (this.$refs.modelViewFormComponent as any).getFormValues();
    if (!allData.valid) {
      this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
      return false;
    }
    formData = {
      clientType: "web",
      dataViewCfgId: this.pageData.dataViewCfgId,
      fields: allData.data,
      flowCfgId: this.pageData.flowConfigId,
      ifProcess: this.pageData.ifProcess,
      attIds: null,
      ccs: null
    };
    try {
      const { success, message } = await request({
        url: this.prefix + Api.createDyForm(),
        method: "post",
        data: formData
      });
      if (!success) {
        this.$message.error("新增失败:" + message);
      }
      this.$message.success("新增成功");
      this.$emit("childEvt", { type: "sure" });
    } catch (error: any) {
      this.$message.error("新增失败:" + error);
    }
  }

  /*修改*/
  async update() {
    const allData = await (this.$refs.modelViewFormComponent as any).getFormValues();
    if (!allData.valid) {
      this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
      return false;
    }
    try {
      const { success, message } = await request({
        url: this.prefix + Api.updDyForm(),
        method: "put",
        data: {
          fields: allData.data,
          businessId: this.pageData.data.businessId,
          dataCfgId: this.pageData.dataConfigId,
          pacId: this.pageData.pacId,
          reqToken: this.pageData.reqToken
        }
      });
      if (!success) {
        this.$message.error("修改失败:" + message);
      }
      this.$message.success("修改成功");
      this.$emit("childEvt", { type: "sure" });
    } catch (error: any) {
      this.$message.error("修改失败:" + error);
    }
  }

  /*点击确定*/
  async modalEvt(type: any) {
    if (type === "sure") {
      if (this.pageData.type === "add") {
        this.add();
      } else {
        this.update();
      }
    } else {
      this.$emit("childEvt", { type: "cancel" });
    }
  }
}
